import { ROLE_STATE_NAME, RoleState } from './role/role.state';
import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { RoleReducer } from 'projects/access-control/src/app/Infrastructure/Store/role/role.reducer';
import * as fromModule from './systems-module/systems-module.reducer';
import { environment } from 'projects/access-control/src/environments/environment';
import { InjectionToken } from '@angular/core';
import { SystemsModuleEffects } from './systems-module/systems-module.effects';
import {
	SystemsModuleState,
	SYSTEMS_MODULE_STATE_NAME,
} from './systems-module/systems-module.state';
import { CLIENTS_STATE_NAME } from './clients/clients.state';
import { reducerClient } from './clients/clients.reducer';
import { ClientEffects } from './clients/clients.effects';
import { RoleEffects } from './role/role.effects';
import { GroupState, GROUPS_STATE_NAME } from './groups/groups.state';
import { reducerGroup } from './groups/groups.reducer';
import { GroupEffects } from './groups/groups.effects';
import { UsersState, USERS_STATE_NAME } from './users/users.state';
import { reducerUsers } from './users/users.reducer';
import { UsersEffects } from './users/users.effects';

export interface AppState {
	[ROLE_STATE_NAME]?: RoleState;
	[SYSTEMS_MODULE_STATE_NAME]?: SystemsModuleState;
	[GROUPS_STATE_NAME]?: GroupState;
	[USERS_STATE_NAME]?: UsersState;
}

export const reducers: ActionReducerMap<any> = {
	[SYSTEMS_MODULE_STATE_NAME]: fromModule.reducer,
	[ROLE_STATE_NAME]: RoleReducer,
	[CLIENTS_STATE_NAME]: reducerClient,
	[GROUPS_STATE_NAME]: reducerGroup,
	[USERS_STATE_NAME]: reducerUsers,
};

export const EffectsArray: any[] = [
	SystemsModuleEffects,
	ClientEffects,
	RoleEffects,
	GroupEffects,
	UsersEffects,
];

export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [] : [];

export const REDUCERS_TOKEN = new InjectionToken<ActionReducerMap<AppState>>('App Reducers');
export const reducerProvider = { provide: REDUCERS_TOKEN, useValue: reducers };
